import { deserializeWith, rename, t, u } from "desero";

/**
 * A category of a meal.
 * @hideconstructor
 */
export class FoodCategory {
  /**
   * All dishes available in this category.
   */
  @deserializeWith((plat) => {
    if (Array.isArray(plat)) {
      return u.pick("nom")(plat);
    }

    return [plat.nom];
  })
  @rename("plat")
  dishes = t.array(t.string());

  /**
   * Name of the category.
   */
  @rename("nom")
  name = t.string();
}
